export const BASE_URL = "https://openmind-api.vercel.app/12-1";
